import styled from "@emotion/styled";
import { fontRoboto } from "@product/scmp-sdk";

import { ContentShareWidget } from "~/components/content/content-share-widget";
import { StyledShareButton } from "~/components/content/content-share-widget/styles";

export const Container = styled.div`
  position: relative;

  display: flex;
  flex-flow: column nowrap;

  margin-block: 12px 34px;

  &::before {
    position: absolute;
    inset-block-start: 0;
    inset-inline-start: 0;
    content: "";

    inline-size: calc(100% - 90px);
    margin-inline-end: 40px;
    border-block-start: 6px #ffca05 solid;

    ${props => props.theme.breakpoints.only("mobile")} {
      inline-size: 100%;
    }
  }
`;

export const Blockquote = styled.blockquote`
  margin-block: 38px 28px;
  padding-inline: 90px;

  color: #001246;
  font-weight: 300;
  font-size: 28px;
  font-family: ${fontRoboto};
  line-height: 36px;

  ${props => props.theme.breakpoints.only("mobile")} {
    padding-inline: 0;

    font-size: 24px;
    line-height: 32px;
  }
`;

export const Author = styled.figcaption`
  color: #ffca05;
  font-weight: 500;
  font-style: italic;
`;

export const StyledContentShareWidget = styled(ContentShareWidget)`
  position: relative;

  display: flex;
  flex-flow: row nowrap;
  align-self: flex-end;

  inline-size: 100%;

  &::after {
    position: absolute;
    inset-block-start: calc(50% - 3px);
    inset-inline-end: 0;
    content: "";

    inline-size: calc(100% - 48px * ${props => props.types.length});
    border-block-start: 6px #ffca05 solid;
  }

  ${props => props.theme.breakpoints.up("tablet")} {
    inline-size: calc(100% - 80px);
  }

  ${StyledShareButton} {
    inline-size: 48px;
  }
`;
